<template>
  <form v-on:submit="save">

    <div v-show="grid === 'hide'">
      <div class="card card-info" runat="server">
        <div class="card-header with-border">
          <h3 class="card-title">Department Coordinator</h3>
        </div>
        <!-- /.card-header -->
        <!-- form start -->
        <div class=" form-horizontal">

          <div class="row">
            <div class="col-md-12" style="padding-right: 3%; padding-left: 3%;">
              <div class="row" style="margin-top: 10px">
                <div class="col-md-6">
                  Session
                  <select class="form-control" v-model="ActiveSemesterID" v-on:change="loadProgram()">
                    <option value="0" disabled="disabled">--Select Session--</option>
                    <option v-for="item in session" v-bind:value="item.SessionID">{{item.Name}}</option>
                  </select>
                </div>
                <div class="col-md-6">
                  Program
                  <select class="form-control" v-model="ProgramID" v-on:change="loadStudents()">
                    <option value="0" selected="selected" disabled="disabled">--Select Program--</option>
                    <option v-for="item in program" v-bind:value="item.ProgramID">{{item.ProgramName}}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

        </div>
        <hr />
        <!--Button -->
        <div class="card-footer">
          <button type="submit" class="btn btn-success float-right" style="width:120px" v-show="view === 'show'">Save</button>
          <button class="btn btn-danger" v-on:click="cancel()" type="button" style="width:120px">Cancel</button>
        </div>
      </div>
      <div class="card card-info" runat="server" v-show="view === 'show'">
        <div class="card-header with-border">
          <h3 class="card-title">Intership Student ({{ActiveSemester}})</h3>
        </div>
        <!-- /.card-header -->
        <!-- form start -->
        <div class="card-body page-content container-fluid">
          <div class="row" style="margin-top: 10px">
            <div class="col-md-12">
              <table class="table table-bordered table-color" id="table">
                <thead class="bg-info">
                  <tr>
                    <th>Sr. No.</th>
                    <th>
                      <div class="checkbox">
                        <label>
                          <input style="margin-top: 0px;" type="checkbox" v-model="stcheck" v-on:change="masterCheckStudents()">
                          Student Name
                        </label>
                      </div>

                    </th>
                    <th>Father Name</th>
                    <th>Roll No</th>
                    <th>CNIC</th>
                    <th>Mobile No</th>
                    <th>Date</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, ind) in Student">
                    <td>{{ind+1}}</td>
                    <td>
                      <label class="checkbox" style="margin-left: 20px">
                        <input type="checkbox" :value="item.Selected" v-model="item.Selected" style="margin-top: 0px" v-bind:disabled="item.Disabled">
                        {{item.Name}}
                      </label>
                    </td>
                    <td>{{item.FathersName}}</td>
                    <td>{{item.RollNo}}</td>
                    <td>{{item.CNIC}}</td>
                    <td>{{item.MobileNo}}</td>
                    <td>{{item.Date}}</td>
                    <td>{{item.Status}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="grid === 'show'">
      <div class="card card-info" runat="server">
        <div class="card-header with-border">
          <h3 class="card-title"></h3>
          <button v-on:click="changestate()" type="button" class=" float-right btn btn-sm btn-outline-secondary btn-default"> <i class="fa fa-plus"> Add New</i></button>
          <!--<button type="button" class="btn btn-primary" style="float:right" v-on:click="changestate()">+Add New</button>-->
        </div>
        <!-- /.card-header -->
        <!-- form start -->
        <div class="card-body page-content container-fluid">
          <div class="row" style="margin-top: 10px">
            <div class="col-md-6">
              Session
              <select class="form-control" v-model="ActiveSemesterSearchID" v-on:change="loadProgramsearch()">
                <option value="0" disabled="disabled">--Select Session--</option>
                <option v-for="item in sessions" v-bind:value="item.SessionID">{{item.Name}}</option>
              </select>
            </div>
            <div class="col-md-6">
              Program
              <select class="form-control" v-model="ProgramSearchID">
                <option value="0" selected="selected" disabled="disabled">--Select Program--</option>
                <option v-for="item in programs" v-bind:value="item.ProgramID">{{item.ProgramName}}</option>
              </select>
            </div>
            <div class="col-md-12" style="margin-top:15px; text-align:right">
              <button class="btn btn-success" v-on:click="searchGrid()" type="button">Search</button>
            </div>
          </div>
          <div class="row" style="margin-top: 10px">
            <hr />
            <div class="col-md-12">
              <table class="table table-bordered table-color" id="bs4" style="width:100%">
                <thead class="bg-info">
                  <tr>
                    <th>Sr. No.</th>
                    <th>Session</th>
                    <th>Program</th>
                    <th>Student Name</th>
                    <th>Father Name</th>
                    <th>Roll No</th>
                    <th>CNIC</th>
                    <th>Mobile No</th>
                    <th>Letter Issued</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, ind) in stdDetail">
                    <td>{{ind+1}}</td>
                    <td>{{item.Session}}</td>
                    <td>{{item.ProgramName}}</td>
                    <td>{{item.Name}}</td>
                    <td>{{item.FathersName}}</td>
                    <td>{{item.RollNo}}</td>
                    <td>{{item.CNIC}}</td>
                    <td>{{item.MobileNo}}</td>
                    <td>
                      <span v-if="item.LetterIssue">Yes</span>
                      <span v-else>No</span>
                    </td>
                    <td>{{item.Status}}</td>
                    <td style="vertical-align: middle; text-align: center;">
                      <div class="btn-group-vertical">
                        <button type="button" class="btn btn-info" v-on:click="viewdetail(item.DCInternshipStudentID)">View</button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="Modal">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">

            <h4 class="modal-title float-left">Internship Students Detail</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <table class="table table-sm table-bordered table-striped">
              <thead class="bg-info">
                <tr>
                  <th>Organization</th>
                  <th>Contact #</th>
                  <th>Contact Person</th>
                  <th>Designation</th>
                  <th>City Of Organization</th>
                  <th>Sector</th>
                  <th>Evaluation Perfoma</th>
                  <th>Internship Report</th>
                  <th>Experience Certificate</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{std.Organization}}</td>
                  <td>{{std.ContactNo}}</td>
                  <td>{{std.ContactPerson}}</td>
                  <td>{{std.Designation}}</td>
                  <td>{{std.City}}</td>
                  <td>{{std.Sector}}</td>
                  <td>
                    <a v-bind:download="std.EvaluationPerfomaExtentsion" v-if="std.EvaluationPerfoma != '' && std != ''" v-bind:href="std.EvaluationPerfoma"><i class="fa fa-download fa-2x"></i></a><span v-else>No Attachment</span>
                  </td>
                  <td>
                    <a v-bind:download="std.ExperienceCertificateExtentsion" v-if="std.InternshipReport != '' && std != ''" v-bind:href="std.InternshipReport"><i class="fa fa-download fa-2x"></i></a><span v-else>No Attachment</span>
                  </td>
                  <td>
                    <a v-bind:download="std.InternshipReportExtentsion" v-if="std.ExperienceCertificate != '' && std != ''" v-bind:href="std.ExperienceCertificate"><i class="fa fa-download fa-2x"></i></a><span v-else>No Attachment</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal">Close</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </form>
</template>

<script>
  const axios = require('axios').default;

  export default ({
    data() {
      return {
        stdDetail: [],
        Student: [],
        program: [],
        session: [],
        programs: [],
        sessions: [],
        view: 'hide',
        stcheck: false,
        ProgramID: 0,
        ActiveSemesterID: 0,
        ProgramSearchID: 0,
        ActiveSemesterSearchID: 0,
        grid: 'show',
        std: {
          Organization: '',
          ContactNo: '',
          ContactPerson: '',
          Designation: '',
          Sector: '',
          City: '',
          EvaluationPerfoma: '',
          InternshipReport: '',
          ExperienceCertificate: '',
          EvaluationPerfomaExtentsion: '',
          ExperienceCertificateExtentsion: '',
          InternshipReportExtentsion: '',
        },
        ActiveSemester: '',
      }
    },
    created: function () {
      this.pageload();
    },

    updated: function () {
      $('#bs4').DataTable();
      $('#table').DataTable();
    },
    methods:
    {
      pageload() {
        var vm = this;
        startReq();
        axios.post('/api/DCApi/pageloadInternshipStudents')
          .then(function (response) {
            vm.session = response.data.sem;
            vm.sessions = response.data.semsearch;
            vm.stdDetail = response.data.lst;
            endReq();
          })
          .catch(function (error) {
          });
      },

      changestate() {
        this.grid = 'hide';
      },

      searchGrid() {
        var vm = this;
        startReq();
        axios.post('/api/DCApi/searchGrid?progID=' + vm.ProgramSearchID + '&sessID=' + vm.ActiveSemesterSearchID)
          .then(function (response) {
            vm.stdDetail = response.data.lst;
            $('#bs4').DataTable().destroy();
            endReq();
          })
          .catch(function (error) {
          });
      },

      loadProgramsearch() {
        var vm = this;
        startReq();
        vm.ProgramSearchID = 0;
        axios.post('/api/DCApi/loadProgramsearch?id=' + vm.ActiveSemesterSearchID)
          .then(function (response) {
            vm.programs = response.data.sess;
            endReq();
          })
          .catch(function (error) {
          });
      },

      loadProgram() {
        var vm = this;
        startReq();
        vm.ProgramID = 0;
        axios.post('/api/DCApi/loadprogForDCIternship?id=' + vm.ActiveSemesterID)
          .then(function (response) {
            vm.program = response.data.sess;
            endReq();
          })
          .catch(function (error) {
          });
      },

      checkvalidation() {
        if (this.studentactive.CurrentStatus == false) {
          if (this.studentactive.Status == "") {
            toastr.error("Status Is Required", "Error!");
          }
        }
        if (this.studentactive.Remarks == "") {
          toastr.error("Remarks Is Required", "Error!");
        }
        else {
          this.savestudentactive();
        }
      },

      loadStudents: function () {
        var vm = this;
        startReq();
        axios.post('/api/DCApi/loadInternshipStudents?progID=' + vm.ProgramID + '&sessID=' + vm.ActiveSemesterID)
          .then(function (response) {
            $('#table').DataTable().destroy();
            vm.Student = response.data.lst;
            vm.ActiveSemester = response.data.Semester;
            vm.view = 'show';
            endReq();
          })
          .catch(function (error) {
          });
      },

      masterCheckStudents() {
        var vm = this;
        startReq();
        vm.Student.forEach(function (item) {
          item.Selected = vm.stcheck
        })
        endReq();
      },
      cancel() {
        window.location.reload();
      },
      save(e) {
        e.preventDefault();
        var vm = this;
        startReq();
        //vm.Student.filter((x) => { return x.Selected; });
        //if (vm.Student.length == 0) {
        //    toastr.error("No student selected");
        //    return;
        //}
        axios.post('/api/DCApi/saveDCInternshipStudent?progID=' + vm.ProgramID + '&sessID=' + vm.ActiveSemesterID, {
          obj: vm.Student
        })
          .then(function (response) {
        
              toastr.success("Your data is Saved", "Success");
              setTimeout(function () { window.location.reload() }, 1000);
              endReq();
           
          
          })
          .catch(function (error) {
          });
      },

      viewdetail(id) {
        this.std = '';
        var vm = this;
        axios.post('/api/DCApi/ViewinternshipStudnetRecord?id=' + id)
          .then(function (response) {
            $('#Modal').modal('show');
            if (response.data.data != null) {
              vm.std = response.data.data;
            }
          })
      },
    }
  })
</script>



// WEBPACK FOOTER //
// src/components/DC/dcInternshipStudents.vue